import type { FaireProductEntity } from "../../entity_types/product";

export const p_day9fy2s3n: FaireProductEntity = {
  token: "p_day9fy2s3n",
  type: "product",
  name: "Bookish BOOK DANGLES",
  brandToken: "b_h93v6v8mbm",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/651c713d338b35fdc89de76f6462ef16f2588c92b53108e5d13d6a51701be77d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4e3f822cd204bf8fd996a5aac293c960711cd8d38c62c90369d45dea8cf39da3.jpeg",
    "https://cdn.faire.com/fastly/3d5e2fa0d20ec6b26b3dfbb18b7ab5a3be502c062208b97c02cac53e3551dac1.jpeg",
  ],
  priceDollars: 19.4,
  description:
    "Show your love for literature with Aurora Boheme's Bookish BOOK DANGLES. These handcrafted dangle earrings are a symbol of your intellectual prowess and a statement of self-expression. Unique and bohemian-inspired, they make you feel beautiful and confident every day. Aurora Boheme was born from a desire to explore creative passions, and our mission is to help you express yours.",
  tags: [],
  msrpDollars: 38.8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:26.123Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
